import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaUser,
  FaBlog,
  FaBook,
  FaSignOutAlt,
  FaSun,
  FaMoon,
  FaBars,
  FaTimes,
  FaCommentDots,
  FaComments,
} from "react-icons/fa";
import Courses from "./Courses";
import Blogs from "./Blogs";
import Users from "./Users";
import InquiryForm from "./InquiryForm";
import LoadingSpinner from "../components/LoadingSpinner";
import Adminfeedbacks from "./Adminfeedbacks";

import "../styles/AdminDashboard.css";
import drpmain from "../images/DRP12.png";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import AdminChatDashboard from "../components/AdminChatDashboard";

const AdminDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [selectedContent, setSelectedContent] = useState("users");
  const [isDarkMode, setIsDarkMode] = useState(
    localStorage.getItem("darkMode") === "true"
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [adminUser, setAdminUser] = useState(null); // Store admin user data
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Admin Panel - DRP";

    // Get admin user from localStorage or fetch from API
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user") || "{}");

    if (!token || user.role !== "admin") {
      navigate("/login");
      return;
    }

    setAdminUser(user);
  }, [navigate]);

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [isDarkMode]);

  const menuItems = [
    { id: "users", label: "Users", icon: <FaUser /> },
    { id: "blogs", label: "Blogs", icon: <FaBlog /> },
    { id: "courses", label: "Courses", icon: <FaBook /> },
    { id: "chats", label: "Chat Dashboard", icon: <FaComments /> }, // NEW
    { id: "inquiry", label: "Inquiry", icon: <FaCommentDots /> },
    { id: "Feedback", label: "Feedback", icon: <FaCommentDots /> },
  ];

  const handleContentChange = (content) => {
    setLoading(true);
    setSelectedContent(content);
    setIsSidebarOpen(false);
    setTimeout(() => setLoading(false), 200);
  };

  if (loading)
    return (
      <div className="loading-spinner">
        <LoadingSpinner />
      </div>
    );

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };

  const toggleDarkMode = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    localStorage.setItem("darkMode", newMode);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const renderContent = () => {
    switch (selectedContent) {
      case "users":
        return <Users />;
      case "blogs":
        return <Blogs />;
      case "courses":
        return <Courses />;
      case "chats":
        return <AdminChatDashboard adminUser={adminUser} />;
      case "inquiry":
        return <InquiryForm />;
      case "Feedback":
        return <Adminfeedbacks />;
      default:
        return <p>Invalid Content</p>;
    }
  };

  return (
    <>
      <Header />

      <div className={`dashboard-container ${isDarkMode ? "dark-mode" : ""}`}>
        <div className="hamburger-menu" onClick={toggleSidebar}>
          {isSidebarOpen ? <FaTimes /> : <FaBars />}
        </div>
        <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
          <img src={drpmain} alt="drp" width="160px" />

          <ul>
            {menuItems.map((item) => (
              <li
                key={item.id}
                onClick={() => handleContentChange(item.id)}
                className={selectedContent === item.id ? "active" : ""}
              >
                {item.icon}
                <span>{item.label}</span>
              </li>
            ))}
            <li onClick={handleLogout} className="logout-button">
              <FaSignOutAlt />
              <span>Logout</span>
            </li>
          </ul>
        </div>

        <div className="main-content">
          <header className="header">
            <div className="logo">
              <h1>DRP Admin Panel</h1>
            </div>
            <div className="header-right">
              <div className="dark-mode-toggle" onClick={toggleDarkMode}>
                {isDarkMode ? <FaSun /> : <FaMoon />}
              </div>
            </div>
          </header>
          {renderContent()}
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
